import BaseProxyAcquisition from "@/proxies/base-proxy-acquisition";
import { LocalStoreManager as LocalStore } from "@sleek/customer-common-acquisition";

export class OrderProxy {
  constructor() {}

  async createOrder(data) {
    try {
      let baseProxy = new BaseProxyAcquisition();

      let backendUrl = await baseProxy.getAcquisitionUrl();
      let endpointUrl = `${backendUrl}/order/create-order`;

      return await baseProxy.postData(endpointUrl, data);
    } catch (error) {
      console.error("Error while paying with card", error);
      throw error;
    }
  }

  async processBeforePayment(data) {
    try {
      let baseProxy = new BaseProxyAcquisition();

      let backendUrl = await baseProxy.getAcquisitionUrl();
      let endpointUrl = `${backendUrl}/stripe-payment/process-before-payment`;

      return await baseProxy.postData(endpointUrl, data);
    } catch (error) {
      console.error("Error while paying with card", error);
      throw error;
    }
  }

  async updateOrder(orderId, data) {
    try {
      let baseProxy = new BaseProxyAcquisition();

      let backendUrl = await baseProxy.getAcquisitionUrl();
      let endpointUrl = `${backendUrl}/order/update-order/${orderId}`;
      let localStore = new LocalStore();
      let authToken = localStore.getToken();

      if (authToken) {
        delete data.checkoutItems;
        return await baseProxy.putAuthenticatedData(
          endpointUrl,
          authToken,
          data
        );
      } else {
        return await baseProxy.putData(endpointUrl, data);
      }
    } catch (error) {
      console.error("Error while paying with card", error);
      throw error;
    }
  }

  async getOrderById(orderId) {
    try {
      let baseProxy = new BaseProxyAcquisition();

      let backendUrl = await baseProxy.getAcquisitionUrl();
      let endpointUrl = `${backendUrl}/order/${orderId}`;

      return await baseProxy.getUnauthenticatedData(endpointUrl, {
        authToken: null,
      });
    } catch (error) {
      console.error("Error while paying with card", error);
      throw error;
    }
  }
}
